export enum InsuranceTypeEnum {
  Medicare = 1,
  MedicareHMO = 2,
  Medicaid = 3,
  MedicaidHMO = 4,
  WorkersComp = 5,
  TitlePrograms = 6,
  OtherGovt = 7,
  Private = 8,
  PrivateHMO = 9,
  Other = 99
}

export const InsuranceTypeOptions = [
{ id: 1, label: 'Medicare (traditional fee-for-service)' },
{ id: 2, label: 'Medicare (HMO/managed care/Advantage plan)' },
{ id: 3, label: 'Medicaid (traditional fee-for-service)' },
{ id: 4, label: 'Medicaid (HMO/managed care)' },
{ id: 5, label: 'Workers\' Compensation' },
{ id: 6, label: 'Title programs (for example, Title III, V, or XX)' },
{ id: 7, label: 'Other government (for example, TriCare, VA)' },
{ id: 8, label: 'Private insurance' },
{ id: 9, label: 'Private HMO/managed care' },
{ id: 99, label: 'Other' }
];
